/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const BasketUpdate: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M23 5.99984H19.009L15.868 0.503838C15.595 0.0248382 14.984 -0.142162 14.504 0.131838C14.025 0.404838 13.858 1.01684 14.132 1.49584L16.705 5.99984H7.294L9.868 1.49584C10.142 1.01684 9.975 0.405838 9.496 0.131838C9.018 -0.142162 8.406 0.0248382 8.132 0.503838L4.991 5.99984H1C0.448 5.99984 0 6.44684 0 6.99984V9.99984C0 10.5528 0.448 10.9998 1 10.9998H2V21.9998C2 22.5528 2.448 22.9998 3 22.9998H10V20.9998H4V10.9998H23C23.552 10.9998 24 10.5528 24 9.99984V6.99984C24 6.44684 23.552 5.99984 23 5.99984Z'
      fill='currentColor'
    />
    <path
      d='M18.0002 13C15.7172 13 13.7262 14.542 13.1582 16.751L15.0952 17.249C15.4362 15.925 16.6302 15 18.0002 15C18.8082 15 19.5732 15.331 20.1312 15.893L18.5232 17.061L22.7922 18L23.2202 13.649L21.7542 14.714C20.8132 13.644 19.4502 13 18.0002 13Z'
      fill='currentColor'
    />
    <path
      d='M18.0003 22C17.1923 22 16.4273 21.669 15.8693 21.107L17.4773 19.939L13.2083 19L12.7803 23.351L14.2463 22.286C15.1873 23.356 16.5503 24 18.0003 24C20.2833 24 22.2743 22.458 22.8423 20.249L20.9053 19.751C20.5643 21.075 19.3703 22 18.0003 22Z'
      fill='currentColor'
    />
  </React.Fragment>
)
